import confetti from "canvas-confetti";

// The payoff moment: two side cannons in the brand palette, fired once when
// the handoff lands. Respects reduced-motion; the cleanup cancels a pending
// second burst and clears the canvas if the step goes away mid-celebration.
const COLORS = ["#2d2357", "#00856f", "#2ec4b6", "#ffffff", "#ffd166"];

export function fireSideCannons(): () => void {
  const defaults: confetti.Options = {
    colors: COLORS,
    disableForReducedMotion: true,
    ticks: 260,
    gravity: 0.9,
    zIndex: 10000,
  };
  const fire = (side: "left" | "right", particleRatio: number, opts: confetti.Options) => {
    confetti({
      ...defaults,
      ...opts,
      origin: { x: side === "left" ? 0 : 1, y: 0.75 },
      angle: side === "left" ? 60 : 120,
      particleCount: Math.floor(220 * particleRatio),
    });
  };
  const burst = () => {
    try {
      (["left", "right"] as const).forEach((side) => {
        fire(side, 0.3, { spread: 30, startVelocity: 65, scalar: 1.1 });
        fire(side, 0.25, { spread: 70, startVelocity: 50 });
        fire(side, 0.3, { spread: 110, decay: 0.91, scalar: 0.9 });
        fire(side, 0.15, { spread: 130, startVelocity: 45 });
      });
    } catch {
      // A celebration must never break the handoff.
    }
  };
  burst();
  const second = window.setTimeout(burst, 240);
  return () => {
    window.clearTimeout(second);
    confetti.reset();
  };
}

export function scheduleCelebration(): () => void {
  let cancelBurst: (() => void) | undefined;
  const timer = window.setTimeout(() => {
    cancelBurst = fireSideCannons();
  }, 350);
  return () => {
    window.clearTimeout(timer);
    if (cancelBurst) cancelBurst();
  };
}
